export class TestsAreDemoFunctions_ImportProtection {
    public static active = true;
}